import { Select } from 'antd';
import React from 'react';

type SupplierSignUpPageLogOffOptionsSelectType = {
  disabled?: boolean;
  value?: string;
  onChange?: (value: string) => void;
};

export const SupplierSignUpPageLogOffOptionsSelect = ({
  disabled,
  value,
  onChange,
}: SupplierSignUpPageLogOffOptionsSelectType) => {
  const logOffOptions = [
    { text: 'Never log off (no timeout)', value: '' },
    { text: '15 minutes', value: '900' },
    { text: '30 minutes', value: '1800' },
    { text: '1 hour', value: '3600' },
    { text: '2 hours', value: '7200' },
    { text: '24 hours', value: '87840' },
    { text: '7 days', value: '604800' },
  ];

  return (
    <Select size="large" disabled={disabled} value={value} onChange={onChange}>
      {logOffOptions.map(({ text, value }: { text: string; value: string }) => (
        <Select.Option key={value} value={value}>
          {text}
        </Select.Option>
      ))}
    </Select>
  );
};
